export const UserGroupType = {
  device: "device",
  viewer: "viewer"
};
